var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1300px",
    height: "1300px",
    viewBox: "0 0 1300 1300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 71") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-3794.000000, -4745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-71",
    transform: "translate(3794.000000, 4745.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-93",
    x: 0,
    y: 0,
    width: 1300,
    height: 1300
  }), /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(138.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 43.833333)",
    fill: "#F8B64C",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.004167,486.55 C4.37083333,436.141667 0,56.9833333 0,52.6 L0,19.725 L260.064583,19.725 L260.064583,87.6666667 L69.9333333,87.6666667 C80.8604167,173.141667 131.125,387.925 397.745833,422.991667 L389.004167,486.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.995833,486.55 L651.254167,420.8 C917.875,385.733333 970.325,170.95 979.066667,85.475 L788.935417,85.475 L788.935417,19.725 L1049,19.725 L1049,52.6 C1049,56.9833333 1044.62917,436.141667 659.995833,486.55 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M655.625,789 L393.375,789 L395.560417,786.808333 C439.26875,764.891667 465.49375,721.058333 465.49375,670.65 L465.49375,670.65 L581.320833,670.65 L581.320833,670.65 C581.320833,718.866667 609.73125,764.891667 651.254167,786.808333 L655.625,789 Z",
    id: "Path",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.385417,0 L207.614583,0 C196.6875,52.6 190.13125,109.583333 190.13125,168.758333 C190.13125,376.966667 364.964583,556.683333 461.122917,639.966667 L587.877083,639.966667 C684.035417,556.683333 858.86875,376.966667 858.86875,168.758333 C858.86875,109.583333 852.3125,52.6 841.385417,0 Z",
    id: "Path",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(327.812500, 613.666667)",
    fill: "#F8B64C",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.547917,0 L118.0125,0 C102.714583,0 89.6020833,13.15 89.6020833,28.4916667 C89.6020833,43.8333333 102.714583,56.9833333 118.0125,56.9833333 L277.547917,56.9833333 C292.845833,56.9833333 305.958333,43.8333333 305.958333,28.4916667 C305.958333,13.15 292.845833,0 277.547917,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.997917,175.333333 L63.3770833,175.333333 C30.5958333,175.333333 4.37083333,201.633333 4.37083333,234.508333 L389.004167,234.508333 C389.004167,201.633333 362.779167,175.333333 329.997917,175.333333 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M729.929167,848.175 L319.070833,848.175 C295.03125,848.175 275.3625,867.9 275.3625,892.008333 L275.3625,1052 L773.6375,1052 L773.6375,892.008333 C773.6375,867.9 753.96875,848.175 729.929167,848.175 Z",
    id: "Path",
    fill: "#40596B"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8B64C",
    points: "525 96 559.823529 203.423077 673 203.423077 581.588235 271.384615 616.411765 381 525 313.038462 433.588235 381 468.411765 271.384615 377 203.423077 490.176471 203.423077"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.ef3c99abef9b017236b43dc51e06caab.svg";
export { ForwardRef as ReactComponent };